import i18n, { TFunction } from 'i18next'
import * as Yup from 'yup'
import { ARTICLE, CUSTOM_VALIDATION_ERRORS } from '../../../models/enums'

const regExEmail =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,61}))$/
const regExTextStreet =
  /^[^\s][0-9\sa-zA-ZÄÅáâäàãåÉéêëèíîïìÖóôöòõÜúüûùÇçÑñŠšß.'-ß|/()`´'-._]*$/
const regExTextStreetNumber = /^[^\s][0-9\sa-zA-ZäöüÄÖÜ'-ß|/()`´'-._]*$/
const regExTextZipCode = /^[^\s][0-9a-zA-Z-]*$/
const regExTextPlace =
  /^[^\s|(|)][\sa-zA-ZÄÅáâäàãåÉéêëèíîïìÖóôöòõÜúüûùÇçÑñŠšß.'\-()]*$/
const regExMobilePhoneNumber = /^[0-9]*$/;
const getValidationSchema = (t: TFunction) => {
  const addressObject = {
    hasCompanyName: Yup.boolean(),
    companyName: Yup.string().when('hasCompanyName', {
      is: true,
      then: Yup.string().required(CUSTOM_VALIDATION_ERRORS.valueInvalid(t('contact-details:companyName'), ARTICLE.EINE)),
      otherwise: Yup.string(),
    }),
    street: Yup.string().when('isManual', {
      is: true,
      then: Yup.string()
        .required(CUSTOM_VALIDATION_ERRORS.valueInvalid(t('contact-details:street'), ARTICLE.EINE))
        .matches(regExTextStreet, CUSTOM_VALIDATION_ERRORS.valueInvalid(t('contact-details:street'), ARTICLE.EINE))
        .min(2, i18n.t('validation:minLength', { value: 2 }))
        .max(60, i18n.t('validation:maxLength', { value: 60 })),
      otherwise: Yup.string().required(CUSTOM_VALIDATION_ERRORS.valueInvalid(t('contact-details:street'), ARTICLE.EINE))
    }),
    houseNumber: Yup.string()
      .required(CUSTOM_VALIDATION_ERRORS.valueInvalid(t('contact-details:houseNumber'), ARTICLE.EINE))
      .matches(regExTextStreetNumber, CUSTOM_VALIDATION_ERRORS.valueInvalid(t('contact-details:houseNumber'), ARTICLE.EINE))
      .min(1, i18n.t('validation:minLength', { value: 1 }))
      .max(10, i18n.t('validation:maxLength', { value: 10 })),
    zipCode: Yup.string().when('isManual', {
      is: true,
      then: Yup.string()
        .required(CUSTOM_VALIDATION_ERRORS.valueInvalid(t('contact-details:zipCode'), ARTICLE.EINE))
        .matches(regExTextZipCode, CUSTOM_VALIDATION_ERRORS.valueInvalid(t('contact-details:zipCode'), ARTICLE.EINE))
        .min(2, i18n.t('validation:minLength', { value: 3 }))
        .max(10, i18n.t('validation:maxLength', { value: 10 })),
      otherwise: Yup.string().required(CUSTOM_VALIDATION_ERRORS.valueInvalid(t('contact-details:zipCode'), ARTICLE.EINE))
    }),
    city: Yup.string().when('isManual', {
      is: true,
      then: Yup.string()
        .required(CUSTOM_VALIDATION_ERRORS.valueInvalid(t('contact-details:city'), ARTICLE.EINEN))
        .matches(regExTextPlace, CUSTOM_VALIDATION_ERRORS.valueInvalid(t('contact-details:city'), ARTICLE.EINEN))
        .min(2, i18n.t('validation:minLength', { value: 2 }))
        .max(35, i18n.t('validation:maxLength', { value: 35 })),
      otherwise: Yup.string().required(CUSTOM_VALIDATION_ERRORS.valueInvalid(t('contact-details:city'), ARTICLE.EINEN))
    }),
    countryCode: Yup.string().required(i18n.t('validation:required')),
    state: Yup.string().when('countryCode', {
      is: (v) => v === 'CA' || v === 'US',
      then: Yup.string().required(CUSTOM_VALIDATION_ERRORS.valueInvalid(t('contact-details:state'), ARTICLE.EINEN)),
    }),
  }
  return Yup.object().shape({
    addresses: Yup.array().of(Yup.object().shape(addressObject)),
    contactData: Yup.object({
      mobilePhoneNumber: Yup.string()
        .required(CUSTOM_VALIDATION_ERRORS.valueInvalid(t('contact-details:mobilePhoneNumberTitle'), ARTICLE.EINE))
        .min(3, i18n.t('validation:minLength', { value: 3 }))
        .max(15, i18n.t('validation:maxLength', { value: 15 }))
        .matches(regExMobilePhoneNumber, CUSTOM_VALIDATION_ERRORS.valueInvalid(t('contact-details:mobilePhoneNumberTitle'), ARTICLE.EINE))
        .test(
          'invalidPhoneNumber',
          CUSTOM_VALIDATION_ERRORS.valueInvalid(t('contact-details:mobilePhoneNumberTitle'), ARTICLE.EINE),
          function (this, value) {
            if (!value) {
              return false
            }

            if (
              (this.parent.mobilePhoneCountryCode === '+49' &&
                value.startsWith('0')) ||
              value.startsWith('+49')
            ) {
              return false
            }
            return true
          }
        ),
      mobilePhoneCountryCode: Yup.string().required(
        i18n.t('validation:required')
      ),
      email: Yup.string()
        .matches(regExEmail, CUSTOM_VALIDATION_ERRORS.valueInvalid(t('contact-details:email'), ARTICLE.EINE))
        .required(CUSTOM_VALIDATION_ERRORS.valueInvalid(t('contact-details:email'), ARTICLE.EINE)),
    }),
  })
}

export default getValidationSchema
